(ns frontend.ui.component.lp-portal.big-figure.pdf.view
  (:require
   [clojure.string :as s]
   [frontend.ui.style.theme.core :refer [color]]))

(defn- big-figure
  "Table row of a figure on top of its label. Watch-out: this only works inside a `:table` (because
  we use `:border` and `:borderColor`). See `big-figure-row` for simpler usage."
  [value label {:keys [separator? margin-bottom] :or {separator? true}}]
  {:border      [false false separator? false]
   :borderColor [nil nil (when separator? (color [:lp-report :big-figures :pdf :border])) nil]
   :margin      [0 0 0 margin-bottom]
   :stack       [{:text      value
                  :font      "Palatino"
                  :bold      true
                  :fontSize  30
                  :alignment :center
                  :margin    [0 8 0 -16]
                  :color     (color [:lp-report :big-figures :pdf :value])}
                 {:text      (s/upper-case label)
                  :bold      true
                  :color     (color [:lp-report :big-figures :pdf :label])
                  :alignment :center}]})

(defn table
  ([figures figures-per-row]
   (table figures figures-per-row {:row-gap 0}))
  ([figures figures-per-row {:keys [row-gap]}]
   (let [rows (->> figures
                   (partition figures-per-row figures-per-row (repeat nil)))
         table
         {:margin [0 24 0 24]
          :table  {:widths "*"
                   :body
                   (->>
                    rows
                    (map-indexed
                     (fn [row-index figures-row]
                       (->> figures-row
                            (map (fn [bf]
                                   (if (nil? bf)
                                     {:border [false false false false]
                                      :text   ""}
                                     (big-figure (first bf)
                                                 (second bf)
                                                 {:separator?    false
                                                  :margin-bottom (when-not (= (inc row-index)
                                                                              (count rows))
                                                                   row-gap)})))))))
                    (vec))}}]
     table)))


#_(let [first-figures (->> (butlast figures)
                           (map #(apply big-figure %)))
        last-figure (->> (last figures)
                         (apply #(big-figure %1 %2 :separator? false)))]
    {:table {:widths "*"
             :body   [(concat first-figures [last-figure])]}})
